export var estimatedCostFormTourSteps = [
    {
        element: '#customer_text_field-ocr-preview',
        popover: {
            title: '取引先を選択してください（OCRで自動入力された場合も確認・変更できます）',
            side: 'bottom'
        },
        autoAdvanceTrigger: 'custom-dropdown'
    },
    {
        element: 'button.c-ocr_preview_footer__save-btn',
        popover: {
            title: '内容を確認したら「この内容で登録」で保存します',
            side: 'top'
        }
    }
];
